// extracted by mini-css-extract-plugin
module.exports = {"imgCellsWithText":"ImgCellsWithText_imgCellsWithText__gJF8m"};